type CoordinateData = {
  x: number;
  y: number;
};

class Coordinate implements CoordinateData {
  static ROUNDING = 2;
  /**
   * Defaults to 0 if CoordinateData.x is invalid
   */
  x: number = 0.0;
  /**
   * Defaults to 0 if CoordinateData.y is invalid
   */
  y: number = 0.0;

  constructor(data: CoordinateData) {
    this.setX(data.x);
    this.setY(data.y);
  }

  setX(percentage: number | null): boolean {
    if (!percentage) return false;
    if (Number.isNaN(percentage)) return false;
    this.x = parseFloat(percentage.toFixed(Coordinate.ROUNDING));
    return true;
  }

  setY(percentage: number): boolean {
    if (!percentage) return false;
    if (Number.isNaN(percentage)) return false;
    this.y = parseFloat(percentage.toFixed(Coordinate.ROUNDING));
    return true;
  }

  static toPercentage(
    coordinate: CoordinateData,
    width: number,
    height: number,
  ): CoordinateData {
    const data = new Coordinate(coordinate);
    data.setX((coordinate.x / width) * 100);
    data.setY((coordinate.y / height) * 100);
    return data;
  }

  toCoordinateData(): CoordinateData {
    return {
      x: this.x,
      y: this.y,
    };
  }

  getCoordinateId(): string {
    return `COORDINATE-${this.x}-${this.y}`;
  }
}
export { Coordinate, CoordinateData };
